(function () {
    "use strict";

    angular.module("sempraWebapp").factory("SavingsViewModel", savingsViewModelFactory);

    /** @ngInject */
    function savingsViewModelFactory($translate) {
        function SavingsViewModel() {
            this.page = 1;
            this.pageSize = 10;
            this.pageOptions = [10, 25, 50, 100];
            this.total = 0;
            this.orderBy = 'createdAt';
            this.order = 'desc';
            this.pagerTranslations = {
                page: $translate.instant('GRID_PAGER_PAGE'),
                rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
                of: $translate.instant('GRID_PAGER_PAGE_OF')
            };
        }

        SavingsViewModel.prototype.paginationChanged = function (page, limit) {
            this.page = page;
            this.pageSize = limit;
        };

        SavingsViewModel.prototype.sortChanged = function (order) {
            if (order.charAt(0) === '-') {
                this.orderBy = order.substring(1);
                this.order = 'desc';
            } else {
                this.orderBy = order;
                this.order = 'asc';
            }
        };

        return SavingsViewModel;
    }
})();
